import React from "react";

export default function GeneralScheduleSlot(props) {
  function iconClass() {
    return `far fa-fw m-r-5 fa-circle text-${props.className}`;
  }
  return (
    <td colSpan={props.toNo - props.fromNo + 1} class="activeSlot">
      <table class="gv_slot">
        <tr>
          <td class="from">{props.from}</td>
          <td class="to">{props.to}</td>
        </tr>
        <tr>
          <td colSpan="2" class="crsName">
            <i class={iconClass()} />
            {props.crsnumE} <br />
            <div>{props.crsName}</div>
          </td>
        </tr>
        <tr>
          <td colSpan="2" class="lectName">
            {props.lectName}
          </td>
        </tr>
        <tr>
          <td class="roomNo">Room # {props.roomNo}</td>
          <td class="lectType">{props.lectType}</td>
        </tr>
      </table>
    </td>
  );
}



// WEBPACK FOOTER //
// ./src/pages/student_schedule/GenearalSchedule/GeneralScheduleSlot.js